<template>
    <div class="player-area-outer">
        <div id="container" ref="container" class="player-area-inner"></div>
    </div>
</template>
<script>

import _ from 'lodash'
import cookie from '@/common/utils/cookie'
import { getUserInfo } from '@/common/utils/common'
import { getNoneCredentialUserInfo, playerDelegate } from '@/common/utils/scalable.player'
import Meta from '@/components/meta/Meta'
import { ATTR_BY_PLAYER_TYPE, PLAYER_TYPE } from '@/common/player.const'
import { setCPTokenResult } from '@/common/utils/apollo.interface'
import { URL_COOKIE_DOMAIN } from '@/common/constant'
import utils from '@/common/util/utils'

export default {
  mixins: [Meta],
  name: 'MobilePlayer',
  props: {
    contentInfo: {
      type: Object
    },
    currentSection: {
      type: String
    }
  },
  components: {
  },
  data () {
    return {

    }
  },
  methods: {
    load: async function (type, id, addinfo = {}) {
      return window.playerInstance.load(type, id)
    },
    // 플레이어 초기화
    playerInit: async function () {
      // 초기화 시 플레이어쪽으로 유저 정보 세팅
      let userInfo = getNoneCredentialUserInfo()
      if (cookie.hasCredential()) {
        userInfo = await getUserInfo()
      }
      window.playerInstance.setUserInfo(userInfo)
      window.playerInstance.unload()
      await this.load(this.contentType, this.contentId)
    },
    setCPTokenResultHandler: function (credential) {
      //credential 저장
      //TODO::적당한 함수가 없어서 직접 세팅, 차후 getDevice 함수 정리하면서 같이 정리필요
      if (credential && credential !== '') {
        utils.queryString.replaceQueryParam('credential', credential, true)
        utils.cookies.setItem('app-credential', encodeURIComponent(credential), null, URL_COOKIE_DOMAIN, '/')
        //플레이어 재진입
        this.playerInit()
      }
    }
  },
  computed: {
    contentType () {
      let _contentType = this.currentSection
      switch (this.currentSection) {
        case 'vod':
          _contentType = this.contentInfo.type === 'onair' ? PLAYER_TYPE.ONAIRVOD : PLAYER_TYPE.VOD
          break
        case 'baseball':
          _contentType = 'baseball'
          break
      }
      return _contentType
    },
    contentId () {
      return _.get(this.contentInfo, ATTR_BY_PLAYER_TYPE[this.currentSection].id, null)
    }
  },
  created () {
    // this.actionButtonSetting()
  },
  mounted () {
    playerDelegate(this, this.$refs.container)
    setCPTokenResult(this.setCPTokenResultHandler) // 아폴로 credential 재발급 응답 함수 선언
  }
}
</script>
<style>

</style>
